export const createCipNavigationParams = (clickData) => {
  const params = new URLSearchParams();

  // Handle alert types
  if (clickData.alertType) {
    if (clickData.alertType === "80") {
      // For "Unclassified" alerts, select all alert types 1-7
      params.set("alertTypes", "1,2,3,5,7");
    } else {
      params.set("alertTypes", clickData.alertType);
    }
  }

  // Handle object name
  if (clickData.objectName?.trim()) {
    params.set("objectName", clickData.objectName.trim());
  }

  // Handle line
  if (clickData.line?.trim()) {
    params.set("line", clickData.line.trim());
  }

  // Handle recipe
  if (clickData.recipe?.trim()) {
    params.set("recipe", clickData.recipe.trim());
  }

  return params;
};

export const navigateToBeveragesWithFilters = (history, clickData) => {
  const params = createCipNavigationParams(clickData);
  history.push(`/dashboard?${params.toString()}`);
};
